/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface ControlFailedDependencyError
 */
export interface ControlFailedDependencyError {
    /**
     * 
     * @type {number}
     * @memberof ControlFailedDependencyError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ControlFailedDependencyError
     */
    title: string;
    /**
     * 
     * @type {Message}
     * @memberof ControlFailedDependencyError
     */
    message: Message;
}

/**
 * Check if a given object implements the ControlFailedDependencyError interface.
 */
export function instanceOfControlFailedDependencyError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ControlFailedDependencyErrorFromJSON(json: any): ControlFailedDependencyError {
    return ControlFailedDependencyErrorFromJSONTyped(json, false);
}

export function ControlFailedDependencyErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlFailedDependencyError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': MessageFromJSON(json['message']),
    };
}

export function ControlFailedDependencyErrorToJSON(value?: ControlFailedDependencyError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': MessageToJSON(value.message),
    };
}

